var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPieChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Business, Statistic / Pie Chart 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.22209 4.60105C6.66665 4.304 7.13344 4.04636 7.6171 3.82976C8.98898 3.21539 9.67491 2.9082 10.5875 3.4994C11.5 4.09061 11.5 5.06041 11.5 7.00001V8.50001C11.5 10.3856 11.5 11.3284 12.0858 11.9142C12.6716 12.5 13.6144 12.5 15.5 12.5H17C18.9396 12.5 19.9094 12.5 20.5006 13.4125C21.0918 14.3251 20.7846 15.011 20.1702 16.3829C19.9536 16.8666 19.696 17.3334 19.399 17.7779C18.3551 19.3402 16.8714 20.5578 15.1355 21.2769C13.3996 21.9959 11.4895 22.184 9.64665 21.8175C7.80383 21.4509 6.11109 20.5461 4.78249 19.2175C3.45389 17.8889 2.5491 16.1962 2.18254 14.3534C1.81598 12.5105 2.00412 10.6004 2.72315 8.86451C3.44218 7.12861 4.65982 5.64492 6.22209 4.60105Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.931 2.55398C18.9917 3.36579 20.6342 5.00831 21.446 7.06901C22.0533 8.61055 20.6569 10 19 10H15C14.4477 10 14 9.5523 14 9.00002V5.00002C14 3.34316 15.3895 1.94669 16.931 2.55398Z",
    fill: "#3B82F6"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPieChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pieChart.e1f58e66d4dde83d82a3a0f0970cba1d.svg";